const ConfigurationHistoryTypes = {
  AREA: 'area',
  BOM_SOURCE: 'bom source',
  WIE: 'wie',
  STATION: 'station',
  SETTINGS: 'settings',
  OPERATION: 'operation',
  HARDWARE: 'hardware',
  PLANT: 'plant',
};

export default ConfigurationHistoryTypes;
